'use client'

import NextImage from 'next/image'
import GalleryNav from './gallery.nav'
import { Text } from '@/components/ui/text'
import { useGallery, useGalleryProps } from './use-gallery'

export type GalleryProps = useGalleryProps

const Gallery = (props: GalleryProps) => {
  const {
    styles,
    className,
    sliderRef,
    instanceRef,
    currentSlide,
    loaded,
    title,
    data
  } = useGallery(props)

  return (
    <section className={styles.base()}>
      <div className={styles.container()}>
        {!!title && (
          <header className={styles.heading()}>
            {!!title && (
              <Text
                as="h2"
                size="heading-md"
                weight="medium"
                className={styles.title()}
              >
                {title}
              </Text>
            )}
          </header>
        )}
        <div className={styles.galleryWrapper()}>
          <div
            ref={sliderRef}
            className={styles.gallery({
              className: `${className} keen-slider`
            })}
          >
            {data.map(({ id, image }) => (
              <div
                key={`gallery-${id}`}
                className={styles.item({ className: 'keen-slider__slide' })}
              >
                <div className={styles.figure()}>
                  <NextImage
                    className={styles.cover()}
                    src={image}
                    alt=""
                    fill
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </div>
              </div>
            ))}
          </div>
          <GalleryNav
            styles={styles}
            currentSlide={currentSlide}
            loaded={loaded}
            instanceRef={instanceRef}
          />
        </div>
      </div>
    </section>
  )
}

export default Gallery
